import React from 'react';
import { Button, TextField, InputAdornment } from '@mui/material';
import { MdClose, MdSearch } from 'react-icons/md';
import Pagination from '../../../components/common/Pagination';
import HitDetails from './HitDetails';
import UnhitDetails from './UnhitDetails';

const ScenarioModal = ({
  isOpen,
  onClose,
  scenario,
  searchTerm,
  onSearch,
  viewType,
  data,
  currentPage,
  itemsPerPage,
  onPageChange,
  onScenarioClick,
  selectedHit,
  selectedUnhit,
  onHitClick,
  onBackFromHit,
  onBackToSummary,
  onBackFromUnhit,
  onDownload
}) => {
  if (!isOpen) return null;

  const renderContent = () => {
    if (selectedHit) {
      return (
        <HitDetails
          hit={selectedHit}
          onBack={onBackFromHit}
          onBackToSummary={onBackToSummary}
        />
      );
    }

    if (selectedUnhit) {
      return <UnhitDetails unhit={selectedUnhit} onBack={onBackFromUnhit} />;
    }

    if (scenario) {
      return (
        <div className="mt-3">
          <h5 className="mb-4">{scenario.scenarioName}</h5>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Search"
              value={searchTerm}
              onChange={onSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MdSearch />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          {viewType === 'hits' && (
            <>
              <h6>Hits ({(data || []).length})</h6>
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Name</th>
                    <th>Processed Name</th>
                  </tr>
                </thead>
                <tbody>
                  {(data || [])
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((hit, index) => (
                      <tr
                        key={index}
                        onClick={() => {
                          // onHitClick(hit)
                        }}
                        // style={{ cursor: 'pointer' }}
                      >
                        <td>{hit.name}</td>
                        <td>{hit.processedName}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}

          {viewType === 'unhits' && (
            <>
              <h6>Unhits ({scenario.unhitCount})</h6>
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Name</th>
                    <th>Processed Name</th>
                  </tr>
                </thead>
                <tbody>
                  {(data || [])
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((unhit, index) => (
                      <tr key={index} 
                        // style={{ cursor: 'pointer' }}
                        >
                        <td>{unhit.name}</td>
                        <td>{unhit.processedName}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}

          <div className="d-flex justify-content-end mt-3">
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil((data || []).length / itemsPerPage)}
              onPageChange={onPageChange}
            />
          </div>

          <div className="d-flex justify-content-center mt-3">
            <Button className="btn cancelButton" onClick={onBackToSummary}>
              Back
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="overflow-auto mt-3 remove-box-shadow">
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>Scenario Name</th>
              <th>Total Records</th>
              <th>Hit Count</th>
              <th>Hit Percentage</th>
              <th>Unhit Count</th>
              <th>Unhit Percentage</th>
            </tr>
          </thead>
          <tbody>
            {((data || [])
              .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
              .map((scenario) => (
                <tr key={scenario.id} style={{ cursor: 'pointer' }}>
                  <td>
                    {scenario.scenarioName}
                  </td>
                  <td>
                    {scenario.totalRecords}
                  </td>
                  <td
                    className="table-link"
                    onClick={(e) => {
                      e.stopPropagation();
                      onScenarioClick(scenario, 'hits');
                    }}
                  >
                    {scenario.hitCount}
                  </td>
                  <td>
                    {scenario.hitPercentage}%
                  </td>
                  <td
                    className="table-link"
                    onClick={(e) => {
                      e.stopPropagation();
                      onScenarioClick(scenario, 'unhits');
                    }}
                  >
                    {scenario.unhitCount}
                  </td>
                  <td>
                    {scenario.unhitPercentage}%
                  </td>
                </tr>
              )))}
          </tbody>
        </table>
        <div className="d-flex justify-content-end mt-3">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil((data || []).length / itemsPerPage)}
            onPageChange={onPageChange}
          />
        </div>
        <div className="d-flex justify-content-center mt-3">
          <button className="btn createButton" onClick={onDownload}>
            Download
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{ maxWidth: '90%', width: '90%' }}>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 d-flex justify-content-between align-items-center">
            {!scenario ? <h5 className="mt-4">Efficiency Report</h5> : <div></div>}
            <button className="border-0 bg-transparent" onClick={onClose}>
              <MdClose color="black" fontSize={20} />
            </button>
          </div>
        </div>
        {renderContent()}
      <div className="d-flex justify-content-end ">
            <button className="btn createButton" onClick={onClose}>
              Close
            </button>
          </div>
      </div>
    </div>
  );
};

export default ScenarioModal;
